import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page35() {
  useEffect(() => {
    document.title = "Маяк — Страница 34"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page33" />
        <ForwardLink href="/page35" />
      </div>

      <p style={{ textAlign: "right" }}>34.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Ты молишься, Уинслоу?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Не так часто, как следовало бы. Но я<br/>
        богобоязненный человек -- если Вы это<br/>
        имеете в виду.
      </p>
      <p>
        МОЛОДОЙ пытается еще раз затянуться. Но не может.<br/>
        Сигарета погасла... <i>но он же только что зажег ее...</i>
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Русский дегтярник мне как-то сказал: твой<br/>
        окурок погас,<br/>
        кто-то где-то думает<br/>
        о тебе плохо.
      </p>
      <p>МОЛОДОЙ смотрит на СТАРИКА. СТАРИК перестает раскачиваться.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Они проклинают твое имя.
      </p>
      <p>
        МОЛОДОЙ снова закуривает сигарету и затягивается, не зная<br/>
        что ответить.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Тост за Эфраима Уинслоу,<br/>
        богобоязненного человека. Пусть он устроится где-нибудь,<br/>
        и никто не сможет ему ничего сказать,<br/>
        чтобы его угольки всегда<br/>
        горели, и пусть страх никогда не покидает<br/>
        его.
      </p>
      <p>СТАРИК поднимает тост и выпивает.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Аминь.
      </p>
      <p>МОЛОДОЙ чувствует себя неловко.</p>
      <br/>
      <p>ВНУТРИ. МАЯЧНАЯ СТАНЦИЯ. РАЗЛИЧНЫЕ МЕСТА – РАБОЧИЙ ДЕНЬ</p>
      <p>– МОЛОДОЙ подметает камбуз.</p>
      <p>– СТАРИК поднимается по лестнице башни. Он делает паузу, чтобы отдышаться.</p>
      <p>– МОЛОДОЙ внутри дымовой трубы и чистит ее.</p>
      <p>– <u>СТАРИК быстро закрывает свой СТОЛ и ЗАПИРАЕТ ЕГО</u>.</p>
      <p>– МОЛОДОЙ заводит часовой механизм.</p>
      <p style={{ textAlign: "right" }}>34.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page33" />
        <ForwardLink href="/page35" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710020958/the-lighthouse-script/nyjexgow11nvlo6acpft.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page35;
